(() => {
  const money = (cents, currency) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD'
  }).format((Number(cents) || 0) / 100);

  const normalize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-');

  document.querySelectorAll('[data-tspp-root]').forEach((root) => {
    root.dataset.tsppReady = 'true';
    const variantsNode = root.querySelector('[data-tspp-variants]');
    if (!variantsNode) return;

    const variants = JSON.parse(variantsNode.textContent || '[]');
    if (!variants.length) return;

    const currency = root.dataset.currency || 'USD';
    const colorIndex = Number(root.dataset.colorIndex ?? -1);
    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const status = root.querySelector('[data-variant-status]');
    const submit = root.querySelector('[data-add-to-cart]');
    const primaryImage = root.querySelector('[data-primary-image], .tspp-gallery__stage img');
    const buttons = [...root.querySelectorAll('[data-option-index]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const initial = variants.find((variant) => String(variant.id) === String(idInput?.value)) || variants[0];
    const selected = [...initial.options];

    const exactVariant = () => variants.find((variant) => variant.options.every((option, index) => option === selected[index]));

    const optionCanSell = (optionIndex, optionValue) => variants.some((variant) => {
      if (!variant.available || variant.options[optionIndex] !== optionValue) return false;
      return variant.options.every((option, index) => index === optionIndex || option === selected[index]);
    });

    const selectImage = (src, alt, imageId) => {
      if (!primaryImage || !src) return;
      primaryImage.src = src;
      primaryImage.srcset = '';
      primaryImage.alt = alt || '';
      thumbs.forEach((thumb) => {
        const active = String(thumb.dataset.imageId) === String(imageId);
        thumb.classList.toggle('is-selected', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };

    const selectColorImageFallback = () => {
      if (colorIndex < 0 || !selected[colorIndex]) return;
      const wanted = normalize(selected[colorIndex]);
      const match = thumbs.find((thumb) => normalize(thumb.dataset.imageAlt).includes(wanted));
      if (match) selectImage(match.dataset.imageSrc, match.dataset.imageAlt, match.dataset.imageId);
    };

    const render = () => {
      buttons.forEach((button) => {
        const index = Number(button.dataset.optionIndex);
        const active = selected[index] === button.dataset.optionValue;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = !optionCanSell(index, button.dataset.optionValue);
      });

      root.querySelectorAll('[data-option-label]').forEach((label) => {
        label.textContent = selected[Number(label.dataset.optionLabel)] || '';
      });

      let variant = exactVariant();
      if (!variant || !variant.available) {
        variant = variants.find((candidate) => candidate.available && candidate.options.every((option, index) => {
          const visibleGroup = root.querySelector(`[data-option-group="${index}"]`);
          return !visibleGroup || option === selected[index];
        })) || variant;
      }

      if (!variant) return;
      variant.options.forEach((option, index) => { selected[index] = option; });
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = money(variant.price, currency);
      if (status) status.textContent = variant.available ? 'READY TO ORDER' : 'CURRENTLY UNAVAILABLE';
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'ADD TO CART — KEEP ROLLING' : 'CURRENTLY UNAVAILABLE';
      }
      if (variant.image) selectImage(variant.image, variant.imageAlt, variant.imageId);
      else selectColorImageFallback();
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      selected[Number(button.dataset.optionIndex)] = button.dataset.optionValue;
      render();
    }));

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      selectImage(thumb.dataset.imageSrc, thumb.dataset.imageAlt, thumb.dataset.imageId);
    }));

    render();
  });
})();
